import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 5000);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3 animate-slide-in-right">
          {/* Tooltip */}
          {showTooltip && (
            <div className="hidden md:flex items-center gap-3 bg-white px-6 py-4 rounded-2xl shadow-2xl border border-gray-100 animate-slide-in-left max-w-xs">
              <div className="flex-1">
                <p className="text-sm font-bold text-[#003847] mb-1">
                  ¿Listo para comenzar?
                </p>
                <p className="text-xs text-gray-600">
                  Escríbenos y te ayudamos a instalar tu máquina
                </p>
              </div>
              <button
                onClick={() => setShowTooltip(false)}
                className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          )}

          {/* WhatsApp Button */}
          <a
            href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300"
            aria-label="Contact us on WhatsApp"
          >
            {/* Pulse Animation */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
            
            {/* Icon */}
            <MessageCircle className="w-8 h-8 relative z-10" />

            {/* Hover Tooltip for Mobile */}
            <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
              Escríbenos
              <div className="absolute top-full right-4 -mt-1 border-4 border-transparent border-t-gray-900"></div>
            </div>
          </a>
        </div>
      )}
    </>
  );
};
